$(function (ws) {
    ws.views.incompletionLog = ws.views.modal.extend({

        events: _.extend({}, ws.views.modal.prototype.events, {
            'click [data-event="continue"]': 'sendDataToSAP',
            'click [data-event="continuea"]': 'sendDataToSAPAM',
            'click [data-event="close"]': 'closeIncompletionLog',
            'click [data-event="closes"]': 'closeIncompletionLog',
            'click [data-event="redirectConvertQuote"]': 'redirectConvertQuote'
        }),

        /**
         * Initialize the component.
         */
        initialize: function () {
            this.$submitStatus = $('#submitStatus');
            this.poValidation = $('.po-validation .message-body');
            this.submitButton = $('.submitToSap');
            this.$tableBody = this.$('.block-incompletion-table-body');
            this.$poErrorsTableBody = this.$('.po-errors-table-body');
            this.$poWarningsTableBody = this.$('.po-warnings-table-body');
            ws.views.modal.prototype.initialize.call(this);
            $('.po-validation .message-body').scroll(this.enableButton.bind(this));
            this.buttonOnLoad();
        },

        closeIncompletionLogQuote: function () {
            this.closeModal();
        },

        /**
         * @param {Object} ev
         */
        sendDataToSAPAM: function (ev) {
            $(ev.currentTarget).prop('disabled', true);
            this.closeModal();
            this.eventAgg.trigger('qut-openSplitOrderEmailModal');
        },

        sendDataToSAP: function (ev) {
            $(ev.currentTarget).prop('disabled', true);
            this.$submitStatus.attr('value', 'SUBMIT');
            this.eventAgg.trigger('skipPoMatchValidation');
            this.eventAgg.trigger('skipEdiMatchValidation');
            this.eventAgg.trigger('skipQuoteMatchValidation');
            this.eventAgg.trigger('submitOrderForm', ev, false);
        },

        /**
         * This function will call function to set Incompletion log table .
         */
        closeIncompletionLog: function () {

            let incompletionTableBody;
            let poValidationErrorBody;
            let poValidationWarningBody;

            if ($('.modal-container .block-incompletion-table-body').length == 0) {
                incompletionTableBody = 'incompletionSuccess';
            } else {
                incompletionTableBody = $('.block-incompletion-table-body').html();
            }

            if (($('.modal-container .po-errors-table-body').length == 0) || ($('.modal-container .po-errors-table-body').html().trim() == '')) {
                poValidationErrorBody = 'poValidationSuccess';
                poValidationWarningBody = 'poValidationSuccess';
            } else {
                poValidationErrorBody = $('.modal-container .po-errors-table-body').html();
                poValidationWarningBody = $('.modal-container .po-warnings-table-body').html();
            }

            this.eventAgg.trigger('setIncompletionTable', incompletionTableBody, poValidationErrorBody, poValidationWarningBody);
            this.closeModal();
        },

        redirectConvertQuote: function () {
            globals.disableApp();
            this.eventAgg.trigger('redirectDirectConvertOrder');
        },

        checkIfDivVisible: function(ele) {
            const rect = ele.getBoundingClientRect();
            return (
                rect.top >= 0 &&
                rect.left >= 0 &&
                rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
                rect.right <= (window.innerWidth || document.documentElement.clientWidth)
            );
        },

        enableButton: function () {

            //if (Math.ceil($('.po-validation .message-body').prop('scrollTop') + 2) + $('.po-validation .message-body').prop('offsetHeight') >= $('.po-validation .message-body').prop('scrollHeight')) {
            if (this.checkIfDivVisible(document.getElementById('warningDivIsVisible'))) {
                $('.submitToSap').removeClass('disabled');
                $('.submitToSap').removeAttr('disabled');
            }

            //}
        },

        buttonOnLoad: function () {
            if ($('.po-validation .message-body').prop('offsetHeight') < $('.po-validation .message-body').prop('scrollHeight')) {
                $('.submitToSap').addClass('disabled');
                $('.submitToSap').attr('disabled', 'true');
            } else {
                $('.submitToSap').removeClass('disabled');
                $('.submitToSap').removeAttr('disabled');
            }
        }
    });
}(westcon));
